(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["minicart"]) return;
  try {
    

// Initialise add-ons feature slider
$(() => {

  // Configure Addon Slider
  let addonsSliderSettings = {
      appendArrows: $('#minicart-addons-content'),
      dots: false,
      draggable: false,
      infinite: false,
      prevArrow: $('.addons-slider-button-previous'),
      nextArrow: $('.addons-slider-button-next'),
      slidesToShow: 1,
      slidesToScroll: 1,
      touchThreshold: 7,
      touchMove: false,
      swipe: false,
      variableWidth: true
  }

  // Initiliase Addons Slider
  $('#addons-slider-container').slick(addonsSliderSettings)
})

  } catch(e) { console.error(e); }
})();
})();
